import React, { Component, Fragment } from 'react'
import { FormattedRelativeTime } from 'react-intl'
import { selectUnit } from '@formatjs/intl-utils'
import PropTypes from 'prop-types'
import Select from 'components/UI/FormInput/SettingsSelect'
import Textarea from 'components/UI/FormInput/Textarea'
import UploadModal from '../UploadModal/UploadModal'
import Button from 'components/UI/Button/Button'
import {
  Wrapper,
  InputTitle,
  ClassBlogSection,
  ClassBlogImage,
  StyledButton,
  ViewBlogButton,
  BattleControlInfo,
  BattleControlText
} from './ClassDetailsColumn.styles'
import {
  Title,
  StyledFormInput,
  InputExplanationText
} from '../../../../DashboardSettings.styles'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'
import { useRouter } from 'next/router'

class ClassDetailsColumn extends Component {
  constructor (props) {
    super(props)

    this.onInputChange = this.onInputChange.bind(this)
  }

  static propTypes = {
    setClassState: PropTypes.func,
    modal: PropTypes.shape({
      close: PropTypes.func,
      open: PropTypes.func
    }),
    initialClassDetails: PropTypes.shape({
      battleLockedUntil: PropTypes.any
    }),
    isEditMode: PropTypes.bool,
    setBattleControlUnlock: PropTypes.func,
    battleControlCustomUnlock: PropTypes.bool,
    classDetails: PropTypes.shape({
      _id: PropTypes.string,
      name: PropTypes.string,
      yearGroup: PropTypes.string,
      description: PropTypes.string,
      headerArtwork: PropTypes.string
    }),
    isParent: PropTypes.bool,
    loading: PropTypes.bool,
    redirectTo: PropTypes.func
  }

  static defaultProps = {
    modal: {},
    initialClassDetails: {},
    classDetails: {}
  }

  onInputChange (e) {
    if (e.target.name === 'battleLockedUntil') {
      const now = Date.now()
      const timestamp = {
        off: '1970-01-01T00:00:00.000Z',
        hour: new Date(now + 60 * 60 * 1000).toISOString(),
        day: new Date(now + 24 * 60 * 60 * 1000).toISOString(),
        week: new Date(now + 7 * 24 * 60 * 60 * 1000).toISOString()
      }

      return this.props.setClassState({
        field: e.target.name,
        value: timestamp[e.target.value]
      })
    }

    this.props.setClassState({
      field: e.target.name,
      value: e.target.value
    })
  }

  openUploadModal () {
    const modal = this.props.modal

    modal.open(
      <UploadModal
        onCancel={() => modal.close()}
        onAfterUpload={() => modal.close()}
        handleNewImageUrl={url =>
          this.props.setClassState({
            field: 'headerArtwork',
            value: url
          })
        }
      />
    )
  }

  renderBattleControlSection (commonProps) {
    const {
      initialClassDetails,
      isEditMode,
      setBattleControlUnlock
    } = this.props
    const { battleLockedUntil } = initialClassDetails

    const now = new Date()
    const expiryTime = new Date(battleLockedUntil)
    const isLocked = now < expiryTime && !this.props.battleControlCustomUnlock

    return (
      <Fragment>
        {!isLocked && (
          <Fragment>
            <Select
              {...commonProps}
              value='off'
              onChange={this.onInputChange}
              name='battleLockedUntil'
              fieldName='Battle Control'
              options={[
                { title: 'unlocked', value: 'off' },
                { title: 'locked (1 hour)', value: 'hour' },
                { title: 'locked (1 day)', value: 'day' },
                { title: 'locked (1 week)', value: 'week' }
              ]}
            />
            <InputExplanationText>
              (Disable the battle game to help students focus on their lessons)
            </InputExplanationText>
          </Fragment>
        )}
        {isLocked && (
          <Fragment>
            <InputTitle>Battle Control</InputTitle>
            <BattleControlInfo>
              <BattleControlText>
                {'Currently locked and will unlock '}
              </BattleControlText>
              <FormattedRelativeTime {...selectUnit(expiryTime, Date.now())} />
            </BattleControlInfo>
            {isEditMode && (
              <Button
                bgColor={colors.orange}
                color='white'
                size='small'
                onClick={() => setBattleControlUnlock(true)}
              >
                Change
              </Button>
            )}
          </Fragment>
        )}
      </Fragment>
    )
  }

  render () {
    const {
      classDetails,
      isEditMode,
      isParent,
      loading,
      redirectTo
    } = this.props
    if (loading) return null

    const defaultImage = `${ASSETS_PATH}/pages/Zoo/ClassBlog/default-banner.jpg`

    const commonProps = {
      placeholderColor: isEditMode ? colors.grey : colors.orange,
      backgroundColor: isEditMode ? null : colors.paleBlue,
      inputColor: isEditMode ? null : colors.darkPurple,
      fieldNameColor: colors.pink,
      width: '220px',
      noBorder: !isEditMode,
      focusColor: colors.orange,
      backgroundFocusColor: colors.lightOrange,
      element: 'button',
      disabled: !isEditMode,
      autoComplete: 'off',
      narrow: true,
      textSize: '15px',
      fieldNameSize: '18px'
    }

    return (
      <Wrapper>
        <Title>{isParent ? 'Team Details' : 'Class Details'}</Title>
        <StyledFormInput
          {...commonProps}
          value={classDetails.name}
          onChange={this.onInputChange}
          name='name'
          fieldName={isParent ? 'Team Name' : 'Class Name'}
          placeholder={isParent ? 'Your team name' : 'Your class name'}
          required
        />
        <Select
          {...commonProps}
          value={classDetails.yearGroup}
          onChange={this.onInputChange}
          name='yearGroup'
          fieldName='Age'
          options={[
            { title: 'up to 7', value: 1 },
            { title: '7-8', value: 2 },
            { title: '8-9', value: 3 },
            { title: '9-10', value: 4 },
            { title: '10-11', value: 5 },
            { title: '11 and above', value: 6 }
          ]}
        />
        <Textarea
          {...commonProps}
          value={classDetails.description}
          onChange={this.onInputChange}
          name='description'
          fieldName={isParent ? 'Team Description' : 'Class Description'}
          placeholder={
            isParent ? 'Your team description' : 'Your class description'
          }
          rows='5'
        />
        <InputTitle>
          {isParent ? 'Team Blog Banner' : 'Class Blog Banner'}
        </InputTitle>
        <ClassBlogSection isEditMode={this.props.isEditMode}>
          <ClassBlogImage imageUrl={classDetails.headerArtwork || defaultImage}>
            {this.props.isEditMode && (
              <StyledButton
                bgColor={colors.orange}
                color='white'
                size='regular'
                onClick={() => this.openUploadModal()}
              >
                Change
              </StyledButton>
            )}
          </ClassBlogImage>
        </ClassBlogSection>
        <ViewBlogButton
          color='white'
          size='small'
          onClick={() => redirectTo(`/zoo/class-blog/${classDetails._id}`)}
        >
          {`View ${isParent ? 'team' : 'class'} blog`}
        </ViewBlogButton>
        {this.renderBattleControlSection(commonProps)}
      </Wrapper>
    )
  }
}

export default (props) => {
  const router = useRouter()
  return <ClassDetailsColumn {...props} redirectTo={router.push} />
}
